export const LOCALE = {
  ae: 'en-AE',
  us: 'en-US',
  uk: 'en-GB',
};

export const COUNTRY_CODE = {
  AE: 'AE',
  US: 'US',
  GB: 'GB',
};

export const CURRENCY_ICON_CLASS_NAME = {
  [COUNTRY_CODE.AE]: 'iconDollar',
  [COUNTRY_CODE.US]: 'iconDollar',
  [COUNTRY_CODE.GB]: 'iconPound',
};
